import React from 'react';
import {Link} from "react-router-dom";
import {signInWithGoogle, signOut, useUser} from "../external/auth";

const Header = () => {
    const user = useUser();

    return (
        <div style={{
            height: '50px',
            width: '100%',
            backgroundColor: 'black',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 20px',
            boxSizing: 'border-box',
        }}>
            <div/>
            <div style={{color: 'white'}}>
                <Link to="/" style={{color: "white"}}><span style={{marginRight: '20px'}}>Home</span></Link>
                <Link to="/about" style={{color: "white"}}><span style={{marginRight: '20px'}}>About</span></Link>
                <Link to="/api" style={{color: "white"}}><span style={{marginRight: '20px'}}>API</span></Link>
                <Link to="/contact" style={{color: "white"}}><span
                    style={{marginRight: '20px'}}>Contact us</span></Link>
            </div>
            <div>

                {user ? (
                    <button style={{
                        backgroundColor: 'white',
                        color: 'black',
                        border: 'none',
                        padding: '5px 10px',
                        cursor: 'pointer',
                        borderRadius: '5px',
                    }} onClick={signOut}>
                        Sign Out
                    </button>
                ) : (
                    <button style={{
                        backgroundColor: 'white',
                        color: 'black',
                        border: 'none',
                        padding: '5px 10px',
                        cursor: 'pointer',
                        borderRadius: '5px',
                    }} onClick={signInWithGoogle}>
                        Sign In
                    </button>
                )}


            </div>
        </div>
    );
}

export default Header;
